import { useSelector, useDispatch } from 'react-redux';
import { CHeader, CToggler, CHeaderBrand } from '@coreui/react';
import { ApplicationState } from '../store';
import React from 'react';
import CIcon from '@coreui/icons-react';
import { useTranslation } from 'react-i18next';
import { I18nUse } from '../utils/I18nUse';
import { AuthUser, getCurrentUser } from '@aws-amplify/auth';
import { useEffect, useState } from 'react';
I18nUse();
const TheHeader: React.FC = () => {
  const dispatch = useDispatch();
  const sidebarShow = useSelector((state: ApplicationState) => state.sidebarShow);
  const state_lang = useSelector((state: ApplicationState) => state.lang);
  const [t, i18n] = useTranslation();
  const [currentUser, setCurrentUser] = useState<AuthUser | null>(null);
    useEffect(() => {
    const fetchUser = async () => {
      try {
        const user = await getCurrentUser();
        setCurrentUser(user);
      } catch (error) {
        setCurrentUser(null);
      }
    };
    fetchUser();
  }, []);
  const toggleSidebarMobile = () => {
    const val = [false, 'responsive'].includes(sidebarShow ?? '') ? true : 'responsive';
    dispatch({ type: 'set', sidebarShow: val });
  };

  return (
    <CHeader className="sed-om-header border-0 ">
      {/* <CToggler inHeader className="ml-md-3 d-lg-none" onClick={toggleSidebarMobile} /> */}
      <CIcon name="cilMenu" className="ml-3 d-lg-none " onClick={toggleSidebarMobile} width={23} />
      <CHeaderBrand className="mx-auto">
        {/* <CHeaderBrand className="mx-auto" to="/"> */}
        <div className="sed-om-header-site">
          <p className="title">{t('取引支援システム(Demo)')}</p>
        </div>
      </CHeaderBrand>

      <div className="sed-om-header-name px-3">
        {currentUser?.signInDetails?.['loginId'] && <p className="name">{currentUser?.signInDetails?.['loginId'] || ''}</p>}
      </div>
    </CHeader>
  );
};

export default TheHeader;
